import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Hourglass } from "lucide-react";

const fmt = (s) => (s ? s.split("-").reverse().join("/") : "—");
const CLS = {
  "En período de prueba": "bg-sky-50 text-sky-700 border-sky-200",
  "Pendiente de firma del contrato": "bg-amber-50 text-amber-700 border-amber-200",
  Finalizado: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "No pactado": "bg-slate-100 text-slate-600 border-slate-200",
  Retirado: "bg-red-50 text-red-700 border-red-200",
};

export const PeriodoPruebaCard = ({ vid }) => {
  const { user } = useAuth();
  const interno = ["admin", "gestor"].includes(user?.role);
  const [p, setP] = useState(null);
  useEffect(() => { if (interno) { api.get(`/vinculaciones/${vid}/periodo-prueba`).then((r) => setP(r.data)).catch(() => setP(null)); } }, [vid, interno]);
  if (!interno || !p) return null;
  const items = [
    ["Fecha de ingreso", fmt(p.fecha_ingreso)], ["Tipo de contrato", p.tipo_contrato],
    ["Inicio del período", fmt(p.inicio)], ["Fin del período", p.fin ? `${fmt(p.fin)} · ${p.dias} días` : "—"],
    ["Días restantes", p.dias_restantes ?? "—"], ["Duración de la vinculación", `${fmt(p.duracion_referencia_fin)} · ${p.duracion_referencia}`],
  ];
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="periodo-prueba-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-semibold text-slate-800"><Hourglass className="h-4 w-4 text-vino-700" /> Período de prueba</p>
        <span className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${CLS[p.estado] || CLS["No pactado"]}`} data-testid="periodo-prueba-estado">{p.estado}</span>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {items.map(([l, v]) => (
          <div key={l}><p className="text-[11px] uppercase tracking-wide text-slate-400">{l}</p><p className="text-sm font-medium text-slate-800" data-testid={`pp-${l.toLowerCase().replace(/\s+/g, "-")}`}>{v}</p></div>
        ))}
      </div>
      <p className="mt-2 text-xs text-slate-500">{p.fuente} · {p.motivo}</p>
    </div>
  );
};
